var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "summary" }, [
    _c("div", { staticClass: "metric" }, [
      _c("strong", { attrs: { id: "metricActivities" } }, [
        _vm._v(_vm._s(_vm.total)),
      ]),
      _c("span", [_vm._v(_vm._s(_vm.$t("activities")))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "metric" }, [
      _c("strong", { attrs: { id: "metricYouth" } }, [
        _vm._v(_vm._s(_vm.totalslots)),
      ]),
      _c("span", [_vm._v(_vm._s(_vm.$t("youngpersonspot")))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "metric" }, [
      _c("strong", { attrs: { id: "metricNeeded" } }, [
        _vm._v(_vm._s(_vm.registered)),
      ]),
      _c("span", [_vm._v(_vm._s(_vm.$t("deployementneed")))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "metric" }, [
      _c("strong", { attrs: { id: "metricOpen" } }, [_vm._v(_vm._s(_vm.open))]),
      _c("span", [_vm._v(_vm._s(_vm.$t("openspace")))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "metric" }, [
      _c("strong", { attrs: { id: "metricConflicts" } }, [
        _vm._v(_vm._s(_vm.double)),
      ]),
      _c("span", [_vm._v(_vm._s(_vm.$t("doubleattendant")))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }